import type { RouteRecordRaw } from 'vue-router'

const Layout = () => import('@/layouts/index.vue')

const routes: RouteRecordRaw = {
  path: '/group',
  component: Layout,
  redirect: '/group/index',
  name: 'Group',
  meta: {
    title: '圈子管理',
    i18n: 'route.breadcrumb.root',
    icon: 'ic:twotone-double-arrow',
  },
  children: [
    {
      path: 'index',
      name: 'GroupIndex',
      component: () => import('@/views/group/index.vue'),
      meta: {
        title: '圈子管理',
        sidebar: false,
        breadcrumb: false,
        activeMenu: "/group"
      },
    }
  ],
}

export default routes
